import React from 'react';

import clsx from 'clsx';

import { PhoneIcon } from 'components/Icons';

import styles from './PhoneTo.module.scss';

interface PhoneToProps {
  number?: string;
  linkClassName?: string;
  iconClassName?: string;
}

const PhoneTo = ({ number, linkClassName, iconClassName }: PhoneToProps) => {
  return (
    <>
      <PhoneIcon className={clsx(styles.icon, iconClassName)} />
      <a className={clsx(styles.link, linkClassName)} href={`tel:${number}`}>
        {number}
      </a>
    </>
  );
};

export default PhoneTo;
